import { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'

function CollapsableComponent({
  title = "Purchase Orders",
  defaultOpen = true,
  isOpen,
  onToggle,
  className = "",
  headerClassName = "",
  contentClassName = "",
  children,
  toolTip = "",
}) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = typeof isOpen === "boolean";
  const expanded = isControlled ? isOpen : internalOpen;

  useEffect(() => {
    if (!isControlled) {
      setInternalOpen(defaultOpen);
    }
  }, [defaultOpen, isControlled]);

  const handleToggle = () => {
    if (!isControlled) {
      setInternalOpen((prev) => !prev);
    }
    if (onToggle) {
      onToggle(!expanded);
    }
  };

  return (
    <div className={`w-full border border-borderColor rounded-[2px] ${className}`}>
      <button
        type="button"
        onClick={handleToggle}
        className={`w-full h-[40px] px-3 border-b border-borderColor bg-white flex items-center justify-between ${headerClassName}`}
      >
        <div className="flex items-center gap-2">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor">
            {title}
          </span>
          {toolTip && (
            <>
              <FaInfoCircle data-tooltip-id={title}
                data-tooltip-html={toolTip} className="w-4 h-4 text-titleColor" />
              <Tooltip id={title} positionStrategy="fixed" />
            </>
          )}
        </div>
        <svg
          className={`w-5 h-5 text-titleColor transition-transform duration-200 ${expanded ? "" : "rotate-180"}`}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12.5L10 7.5L15 12.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div
        className={`transition-opacity duration-200 ease-in-out ${expanded ? "opacity-100" : "hidden opacity-0"
          }`}
      >
        <div className={`w-full p-3 ${contentClassName}`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default CollapsableComponent;
